import { render, staticRenderFns } from "./RmSuggPriceAcquisitionForm.vue?vue&type=template&id=78281ed4&"
import script from "./RmSuggPriceAcquisitionForm.vue?vue&type=script&lang=js&"
export * from "./RmSuggPriceAcquisitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports